"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.loadEnvironmentFile = void 0;

var _fs = _interopRequireDefault(require(57));

var _dotenv = _interopRequireDefault(require(110));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var loadEnvironmentFile = function loadEnvironmentFile(path, encoding, silent) {
  try {
    var data = _fs["default"].readFileSync(path, encoding);

    return _dotenv["default"].parse(data);
  } catch (err) {
    if (!silent) {
      console.error(err.message);
    }

    return {};
  }
};

exports.loadEnvironmentFile = loadEnvironmentFile;
var _default = loadEnvironmentFile;
exports["default"] = _default;